
function User(userData, isLoggedIn = true) {
    if (!userData || !userData.uid || !userData.displayName) {
        return null
    }

    const user = Object.create(User.prototype)
    user.uid = userData.uid
    user.displayName = userData.displayName
    user.photoURL = userData.photoURL || ''
    user.isLoggedIn = userData.isLoggedIn || false

    return user
}

User.prototype.setIsLoggedIn = function() {
    this.isLoggedIn = true
}

User.prototype.setIsLoggedOut = function() {
    this.isLoggedIn = false
}

export default User